import UserService from "./UserService";

const FHIR_BASE_URL = process.env.REACT_APP_FHIR_URL ?? "fhir";

let isInstalled = false;

function normalizePathname(pathname: string): string {
  return pathname.replace(/\/+$/, "");
}

function resolveUrl(value: string): URL {
  return new URL(value, window.location.href);
}

function getRequestUrl(input: RequestInfo | URL): URL {
  if (input instanceof Request) {
    return resolveUrl(input.url);
  }

  if (input instanceof URL) {
    return input;
  }

  return resolveUrl(input.toString());
}

function isFhirRequest(input: RequestInfo | URL): boolean {
  const requestUrl = getRequestUrl(input);
  const fhirBaseUrl = resolveUrl(FHIR_BASE_URL);
  const requestPath = normalizePathname(requestUrl.pathname);
  const fhirPath = normalizePathname(fhirBaseUrl.pathname);

  return (
    requestUrl.origin === fhirBaseUrl.origin &&
    (requestPath === fhirPath || requestPath.startsWith(`${fhirPath}/`))
  );
}

function withAuthorization(
  input: RequestInfo | URL,
  init: RequestInit | undefined,
  token: string
): Request {
  const request = new Request(input, init);
  const headers = new Headers(request.headers);

  headers.set("Authorization", `Bearer ${token}`);

  return new Request(request, { headers });
}

export function installFhirAuthFetch(): void {
  if (isInstalled || typeof window === "undefined" || typeof window.fetch !== "function") {
    return;
  }

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (
    input: RequestInfo | URL,
    init?: RequestInit
  ): Promise<Response> => {
    if (!isFhirRequest(input)) {
      return originalFetch(input, init);
    }

    const token = await UserService.getValidToken();

    if (!token) {
      return originalFetch(input, init);
    }

    return originalFetch(withAuthorization(input, init, token));
  };

  isInstalled = true;
}
